/**
 * @description Asset type logged for performance metrics
 */
export enum AssetTypePM {
	VOD = 'VOD',
	LIVE = 'LIVE',
	SYNCBAK = 'SYNCBAK',
}